import { useState, useEffect } from 'react'
import Snackbar from 'components/imported/Snackbar'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from 'modules/notification/NotificationReducer'
import { getCurrentNotification } from 'modules/notification/NotificationSelector'
import styles from './Notification.module.sass'

const Notification = () => {
  const currentNotification = useSelector(getCurrentNotification)
  const dispatch = useDispatch()
  const [dismissing, setDismissing] = useState(false)
  useEffect(() => {
    let dismissalDelay
    if (dismissing) {
      dismissalDelay = setTimeout(() => {
        dispatch(actions.notificationDequeue(currentNotification.uid))
      }, currentNotification.duration)
    }
    return () => clearTimeout(dismissalDelay)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dismissing, currentNotification.uid, dispatch])
  const handleDismiss = () => {
    setDismissing(true)
    if (currentNotification.onDismiss !== undefined) {
      currentNotification.onDismiss()
    }
  }
  return currentNotification.uid ? (
    <Snackbar
      position="bottom"
      key={currentNotification.uid}
      dismissal={currentNotification.duration}
      onDismiss={handleDismiss}
      className={styles.notification}
    >
      {currentNotification.message}
    </Snackbar>
  ) : null
}

export default Notification
